import { v4 as uuidv4 } from 'uuid';
import { SliderLayout } from '../../../../vtex-apps/slider-layout/SliderLayout/default';
import { FlexLayoutCol } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { StoreImageList } from '../../../../vtex-apps/store-image-list/StoreImageList/default';

export default function BrandGroup() {
	return {
		componentName: 'FlexLayoutRow',
		componentId: uuidv4(),
		componentGroup: 'BrandGroup',
		props: FlexLayoutRow({
			blockClass: 'flex-row__brand-group-1',
			mzTitle: 'MZ | Marcas',
			colSizing: 'auto',
		}).props,
		variables,
		childrenComponents: [
			FlexLayoutCol(
				{
					blockClass: 'flex-col__brand-group-1',
					width: '100%',
				},
				[
					RichText({
						textPosition: 'CENTER',
						text: 'Compre por marcas',
						blockClass: 'header-text__brand-group-1',
					}),
					StoreImageList(
						{
							preload: true,
							height: 90,
							images,
						},
						[
							SliderLayout({
								label: 'slider',
								itemsPerPage: {
									desktop: 7,
									tablet: 5,
									phone: 1,
								},
								blockClass: 'slider__brand-group-1',
								fullWidth: true,
							}),
						],
					),
				],
			),
		],
	};
}

const images = [
	{
		image: 'https://hefesto-upload-images.s3.amazonaws.com/1683046022677-dormed-brand-1.png',
		description: 'Imagem',
	},
	{
		image: 'https://hefesto-upload-images.s3.amazonaws.com/1683046029933-dormed-brand-2.png',
		description: 'Imagem',
	},
	{
		image: 'https://hefesto-upload-images.s3.amazonaws.com/1683046034017-dormed-brand-3.png',
		description: 'Imagem',
	},
	{
		image: 'https://hefesto-upload-images.s3.amazonaws.com/1683046022677-dormed-brand-1.png',
		description: 'Imagem',
	},
	{
		image: 'https://hefesto-upload-images.s3.amazonaws.com/1683046029933-dormed-brand-2.png',
		description: 'Imagem',
	},
	{
		image: 'https://hefesto-upload-images.s3.amazonaws.com/1683046034017-dormed-brand-3.png',
		description: 'Imagem',
	},
	{
		image: 'https://hefesto-upload-images.s3.amazonaws.com/1683046022677-dormed-brand-1.png',
		description: 'Imagem',
	},
	{
		image: 'https://hefesto-upload-images.s3.amazonaws.com/1683046029933-dormed-brand-2.png',
		description: 'Imagem',
	},
	{
		image: 'https://hefesto-upload-images.s3.amazonaws.com/1683046034017-dormed-brand-3.png',
		description: 'Imagem',
	},
	{
		image: 'https://hefesto-upload-images.s3.amazonaws.com/1683046022677-dormed-brand-1.png',
		description: 'Imagem',
	},
];

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--neutral-color-high-light', to: '--brand-group-1-background', name: 'Background' },
			{ from: '--brand-color-primary-pure', to: '--brand-group-1-text-color', name: 'Text' },
			{ from: '--brand-color-primary-pure', to: '--brand-group-1-slider-color', name: 'Slider' },
			{ from: '--white', to: '--brand-group-1-slider-arrow-color', name: 'Arrow' },
			{ from: '--white', to: '--brand-group-1-slider-dots-color', name: 'Dots' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-sm', to: '--brand-group-1-image-radius', name: 'Image Border Radius' },
			{ from: '--border-radius-sm', to: '--brand-group-1-slider-radius', name: 'Slider Border Radius' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxl', to: '--brand-group-1-heading-fontsize', name: 'Heading Fontsize' },
			{ from: '--font-size-lg', to: '--brand-group-1-heading-fontsize-m', name: 'Heading Fontsize Mobile' },
			{ from: '--font-size-md', to: '--brand-group-1-label-fontsize', name: 'Label Fontsize' },
		],
	},
	{
		type: 'fontWeight',
		list: [{ from: '--font-weight-700', to: '--brand-group-1-heading-fw', name: 'Heading' }],
	},
	{
		type: 'typography',
		list: [{ from: '--main-font', to: '--brand-group-1-fontfamily', name: 'Font Family' }],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxs', to: '--brand-group-1-dot-width', name: 'Dot Width' },
			{ from: '--spacing-xxs', to: '--brand-group-1-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-nano', to: '--brand-group-1-dot-height', name: 'Dot Height' },
			{ from: '--spacing-nano', to: '--brand-group-1-dot-height-active', name: 'Dot Height Active' },
		],
	},
];
